import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, Building2 } from "lucide-react";
import { useMall } from "@/context/MallContext";
import { useFeature } from "@/context/SiteModeContext";

/**
 * The demo's own bar — loud and red, because a visitor who clicked "See it live" is standing
 * inside a real working store and needs to know it isn't theirs yet. Home is the way back to
 * the pitch; the mall is never the default exit.
 */
export default function DemoBar() {
    const directoryOn = useFeature("directory");
    const { demo, exitDemo, solo, store } = useMall();
    const navigate = useNavigate();
    if (!demo) return null;

    /** Back to the pitch, always — `/` belongs to whichever shop the visitor last walked into. */
    const back = () => { exitDemo(); navigate("/whitelabel"); };

    return (
        <div className="demo-strip sticky top-0 z-[60] bg-[#c81e1e] text-white shadow-[0_1px_0_rgba(0,0,0,0.25)]"
            data-testid="demo-bar">
            <div className="mx-auto flex min-h-[36px] max-w-[110rem] flex-wrap items-center gap-x-3 gap-y-1 px-4 py-1 sm:px-6">
                <button onClick={back} data-testid="demo-back"
                    className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-white px-3 py-1 text-[11px] font-black uppercase tracking-[0.1em] text-[#c81e1e] transition-transform hover:-translate-x-0.5">
                    <ArrowLeft size={11} /> Home
                </button>
                <span className="shrink-0 whitespace-nowrap rounded-sm bg-white/20 px-2 py-0.5 text-[11px] font-black uppercase tracking-[0.16em] text-white">
                    Live demo
                </span>
                <span className="shrink-0 text-[11px] font-semibold text-white">
                    You're inside {store?.name || "a real shop"} — a working store, not yours yet.
                </span>
                <span className="hidden shrink-0 text-[11px] text-white/80 sm:inline">
                    every product, price and designer you'd get on your own site
                </span>
                <span className="ml-auto flex shrink-0 items-center gap-3">
                    {solo ? (
                        <Link to={`/stores/${solo}`} data-testid="demo-inside-mall"
                            className="inline-flex items-center gap-1 whitespace-nowrap text-[11px] font-medium text-white/85 underline decoration-white/40 hover:text-white">
                            <Building2 size={11} /> Browse directory
                        </Link>
                    ) : (
                        directoryOn && <Link to="/directory" data-testid="demo-directory"
                            className="whitespace-nowrap text-[11px] font-medium text-white/85 underline decoration-white/40 hover:text-white">
                            Browse directory
                        </Link>
                    )}
                    <button onClick={back} data-testid="demo-get-this"
                        className="whitespace-nowrap rounded-full bg-zinc-950 px-3 py-1 text-[11px] font-black uppercase tracking-[0.1em] text-white hover:bg-black">
                        Get this site
                    </button>
                </span>
            </div>
        </div>
    );
}
